export default {
  functionKey: "GAUCHE",
  title: "GAUCHE",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [
    { argumentKey: "Length", name: "Nombre de caractères" }
  ],
  expectedArguments: [
    { name: "Nombre de caractères", argumentKey: "Length", single: true, initialValue: "1" }
  ],
  description: "Retourne les N premiers caractères. (Ex: GAUCHE('helloworld', 3) -> 'hel')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const length = args[0] ?? "1";
    const code = `${destination} = ${origin}.substring(0, ${length});`;
    return { displayCode: code, safeCode: code };
  }
}
